import { CircularProgress } from "@mui/material";
import React from "react";
import { MainDiv } from "../../../components/Profile/Profile.style";
import OccupationSetup from "../../../components/setup/OccupationSetup/OccupationSetup";
import OccupationUserSetup from "../../../components/setup/OccupationSetup/OccupationUserSetup";
import { VolunteerHeading } from "../../../components/Volunteer/Volunteer.style";
import useProfile from "../../../hooks/useProfile";

const OccupationSetupPage = () => {
  const [userData, isLoading] = useProfile();
  if (isLoading) {
    return (
      <MainDiv>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "280px",
          }}
        >
          <CircularProgress />
        </div>
      </MainDiv>
    );
  }
  return (
    <MainDiv>
      <VolunteerHeading>Occupation Setup</VolunteerHeading>
      {userData.ugleve_name === "Admin" ||
      userData.ugleve_name === "Developer" ? (
        <OccupationSetup />
      ) : (
        <OccupationUserSetup />
      )}
    </MainDiv>
  );
};

export default OccupationSetupPage;
